<div class="">
	<div class="app-pad-top_1 app-layout-receipt-statement">
		<ng-container *ngIf="statementEditMode">
			<exg-textarea [caption]="enumSvc.getFieldCaption('Receipt', 'rcptStatementReason')"
			              [(ngModel)]="statementClone.rcptStatementReason">
			</exg-textarea>
			<div class="app-label">
				{{enumSvc.getFieldCaption('Receipt', 'rcptStatementText')}}
			</div>
			<div style="margin: 0 12px">
				<editor #VCCommentEditor name="CommentEditor"
				        class="content app-editor"
				        style="height: 480px"
				        [init]="MCEinit"
				        [(ngModel)]="statementClone.rcptStatementText">
				</editor>
			</div>
		</ng-container>
		<ng-container *ngIf="!statementEditMode">
			<exg-textarea [caption]="enumSvc.getFieldCaption('Receipt', 'rcptStatementReason')"
			              disabled="true"
			              [(ngModel)]="statement.rcptStatementReason">
			</exg-textarea>
			<div style="margin: 0 12px">
				<div class="app-label">
					{{enumSvc.getFieldCaption('Receipt', 'rcptStatementText')}}
				</div>
				<editor #VCCommentViewer name="CommentViewer"
				        class="content app-editor"
				        style="height: 480px"
				        [init]="MCEinitDisabled" [disabled]="true"
				        [(ngModel)]="statement.rcptStatementText">
				</editor>
			</div>
			<p class="typo-small"  *ngIf="statement.rcptStatementTextLCD">
				{{statement.rcptStatementTextLCD | excDate}} {{statement.rcptStatementTextLCU && statement.rcptStatementTextLCU.length > 0 ? '(' + statement.rcptStatementTextLCU + ')' : ''}}
			</p>
		</ng-container>
	</div>
	<!--Vorgang-->
	<ng-container *ngIf="details.taskDetails !== undefined">
		<div class="app-space-right app-space-left">
			<app-drawer-task-details [data]="details.taskDetails"
			                         [oeList]="details.caseOEs"
			                         [Schadenort]="details.caseLocation.data">
			</app-drawer-task-details>
		</div>
	</ng-container>
	<!--Vorgang-->
	<!-- Auftrag-->
	<ng-container *ngIf="(details.caseDetails !== undefined)">
		<div class="app-space-right search-filter-seperator">
			<app-drawer-case-details
				[data]="details.caseDetails"
				[oeList]="details.caseOEs"
				[Schadenort]="details?.caseLocation">
			</app-drawer-case-details>
		</div>
	</ng-container>
	<!--Auftrag-->
</div>
